import { createFeatureSelector, createSelector } from '@ngrx/store'
import { PaymentState } from '../state/payment.state'

const getPaymentState = createFeatureSelector<PaymentState>('payment')

export const getExpensePaymentsHistory = () =>
  createSelector(getPaymentState, state => {
    return state?.expensePaymentHistory
  })
